import React, { useState } from "react";
import { Container, Typography, Card, CardContent, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const CardPaginator = ({ cards = [], deck, userId, onReviewComplete }) => {
    const navigate = useNavigate();
    const [reviewCompleted, setReviewCompleted] = useState(false);

    const handleReviewClick = () => {
        setReviewCompleted(true);
        onReviewComplete(); // Notify parent component (LearningManager)
    };

    return (
        <Container sx={{ textAlign: "center", maxWidth: "70%", margin: "auto" }}>
            <br />
            <Typography
                variant="h5"
                sx={{
                    backgroundColor: "#e3f2fd",
                    textAlign: "center",
                    padding: 2,
                    borderRadius: 1,
                    mb: 2
                }}
            >
                Memorize the following cards of {deck.title}. Quick Test Next!
            </Typography>

            {cards.length > 0 && !reviewCompleted && (
                <Box sx={{ textAlign: "left", mb: 2 }}>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        onClick={handleReviewClick}
                    >
                        Review
                    </Button>
                </Box>
            )}

            {cards.length > 0 ? (
                cards.map((card, index) => (
                    <Card key={card._id} sx={{ mb: 2, boxShadow: 3 }}>
                        <CardContent>
                            <Typography variant="h6">
                                {index + 1}. {card.question}
                            </Typography>
                            <Typography variant="body1" color="textSecondary">
                                {card.answer}
                            </Typography>
                        </CardContent>
                    </Card>
                ))
            ) : (
                <Typography variant="h6" color="textSecondary">
                    No cards found.
                </Typography>
            )}
        </Container>
    );
};

export default CardPaginator;
